import { render, staticRenderFns } from "./RichTextMenu.vue?vue&type=template&id=01f1bf39&scoped=true&"
import script from "./RichTextMenu.vue?vue&type=script&lang=js&"
export * from "./RichTextMenu.vue?vue&type=script&lang=js&"
import style0 from "./RichTextMenu.vue?vue&type=style&index=0&id=01f1bf39&prod&lang=scss&scoped=true&"
import style1 from "./RichTextMenu.vue?vue&type=style&index=1&id=01f1bf39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1bf39",
  null
  
)

export default component.exports